import React from 'react';
import PropTypes from 'prop-types';
import {sizeMapping} from '@assets/const/popupSize';

export default function IconDown({size = '55px', color}) {
  const newSize = sizeMapping[size] || size;

  return (
    <svg
      style={{width: newSize, height: newSize}}
      width={newSize}
      height={newSize}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30" cy="30" r="30" fill={color} />
      <path
        d="M17.9089 27.7478C17.9079 28.0194 17.9679 28.2879 18.0843 28.5333C18.2007 28.7788 18.3706 28.995 18.5815 29.1662L29.4896 37.9496C29.8149 38.2171 30.2229 38.3633 30.644 38.3633C31.0651 38.3633 31.4732 38.2171 31.7985 37.9496L42.7065 28.857C43.0778 28.5484 43.3113 28.1048 43.3556 27.624C43.3999 27.1431 43.2514 26.6643 42.9429 26.293C42.6343 25.9216 42.1908 25.688 41.7101 25.6437C41.2294 25.5994 40.7507 25.7479 40.3795 26.0565L30.6349 34.1853L20.8904 26.3293C20.6235 26.107 20.2986 25.9657 19.954 25.9223C19.6094 25.8788 19.2596 25.9351 18.9459 26.0843C18.6322 26.2335 18.3679 26.4695 18.1841 26.7643C18.0003 27.0591 17.9048 27.4004 17.9089 27.7478Z"
        fill="white"
      />
    </svg>
  );
}
IconDown.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};
